// extracted by mini-css-extract-plugin
module.exports = {"page":"Styles_page__Npi4D","cover":"Styles_cover__1RR4Z","title":"Styles_title__26sk8","ingredients":"Styles_ingredients__14E0U","card":"Styles_card__z613Q"};